import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { MemoryHistory } from 'history';
import { clearRestorationState as clearRestorationStateAction } from 'actions/backRestoration';

export const usePageNavigation = () => {
  const dispatch = useDispatch();
  const history = useHistory() as MemoryHistory;

  const navigateToHome = useCallback(() => {
    dispatch(clearRestorationStateAction());
    history.go(history.length * -1);
  }, [dispatch, history]);

  return {
    navigateToHome,
  };
};
